var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMdThumbup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_md_thumbup",
    transform: "translate(20 21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_md_thumbup-2",
    "data-name": "ic_md_thumbup",
    transform: "translate(-20 -21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129600",
    "data-name": "Path 129600",
    d: "M41.77,33.35a6.21,6.21,0,0,1-1.26,5.83,4.21,4.21,0,0,1-.47,3.5C38.46,45,34.57,45,31.27,45H31a22,22,0,0,1-9.22-2.48,12.26,12.26,0,0,0-4.05-1.27.91.91,0,0,1-.91-.93V23.63a1,1,0,0,1,.17-.56l.1-.11c3.05-3.07,4.37-6.31,6.88-8.84C25.15,13,25.56,11.21,26,9.52,26.3,8.07,27,5,28.58,5c1.85,0,5.55.63,5.55,6.36,0,3.32-2,5.17-2.56,7.39h7.84A4.64,4.64,0,0,1,44,23.29a5.74,5.74,0,0,1-1.49,3.84h0A6.56,6.56,0,0,1,41.77,33.35Z",
    transform: "translate(-5 -4)",
    fill: "#f5bc41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129601",
    "data-name": "Path 129601",
    d: "M16.86,22.89V41.78a2,2,0,0,1-2,1.89H8a2,2,0,0,1-2-1.89V22.89A2,2,0,0,1,8,21h6.78A2,2,0,0,1,16.86,22.89Z",
    transform: "translate(-5 -4)",
    fill: "#b4d6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129602",
    "data-name": "Path 129602",
    d: "M40,42.68C38.46,45,34.57,45,31.27,45H31a22,22,0,0,1-9.22-2.48,12.26,12.26,0,0,0-4.05-1.27.91.91,0,0,1-.91-.93V23.63a1,1,0,0,1,.17-.56c3.88,6.86,11.74,17.15,23.48,16.11a4.21,4.21,0,0,1-.47,3.5Z",
    transform: "translate(-5 -4)",
    fill: "#dca93b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129603",
    "data-name": "Path 129603",
    d: "M16.86,29.61V42.39c0,.7-.91,1.28-2,1.28H8c-1.13,0-2-.58-2-1.28V29.61c0-.7.91-1.28,2-1.28h6.78C16,28.33,16.86,28.91,16.86,29.61Z",
    transform: "translate(-5 -4)",
    fill: "#a2c1b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129604",
    "data-name": "Path 129604",
    d: "M12.79,38.58a1.36,1.36,0,1,0-1.36,1.34,1.36,1.36,0,0,0,1.36-1.34Z",
    transform: "translate(-5 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129605",
    "data-name": "Path 129605",
    d: "M31.26,46H31a22.58,22.58,0,0,1-9.62-2.57,12.06,12.06,0,0,0-3.67-1.17,1.94,1.94,0,0,1-1.89-1.94V23.62a2,2,0,0,1,.56-1.37,30.22,30.22,0,0,0,3.7-4.73,28,28,0,0,1,3.17-4.1,9.036,9.036,0,0,0,1.7-4.13C25.43,7.42,26.24,4,28.58,4c2,0,6.55.72,6.55,7.37a11,11,0,0,1-1.64,5.44c-.17.32-.33.64-.48.94h6.4A5.67,5.67,0,0,1,45,23.29a6.71,6.71,0,0,1-1.37,4.06,7.68,7.68,0,0,1-.77,6.18,7.3,7.3,0,0,1-1.27,5.94,5,5,0,0,1-.73,3.77C39,46,34.7,46,31.26,46ZM18,40.32a11.69,11.69,0,0,1,4.28,1.29A21.13,21.13,0,0,0,31.05,44h.21c2.81,0,6.66,0,8-1.89a3.22,3.22,0,0,0,.33-2.69,1,1,0,0,1,.24-.92,5.21,5.21,0,0,0,1-4.83,1,1,0,0,1,.14-.91,5.6,5.6,0,0,0,.6-5.23,1,1,0,0,1,.16-1A4.75,4.75,0,0,0,43,23.29a3.63,3.63,0,0,0-3.59-3.54H31.56a1,1,0,0,1-1-1.24,12.06,12.06,0,0,1,1.13-2.63,9.25,9.25,0,0,0,1.41-4.51C33.13,7.81,31.6,6,28.58,6c-.18,0-.82.27-1.64,3.72-.42,1.77-.88,3.74-2.22,5.1a25.2,25.2,0,0,0-2.94,3.83,32.47,32.47,0,0,1-3.94,5V40.31Z",
    transform: "translate(-5 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129606",
    "data-name": "Path 129606",
    d: "M14.82,44.67H8a3,3,0,0,1-3-2.89V22.89A3,3,0,0,1,8,20h6.78a3,3,0,0,1,3,2.89V41.78A3,3,0,0,1,14.82,44.67ZM8,22a1,1,0,0,0-1,.89V41.78a1,1,0,0,0,1,.89h6.78a1,1,0,0,0,1-.89V22.89a1,1,0,0,0-1-.89Z",
    transform: "translate(-5 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdThumbup);
export default __webpack_public_path__ + "static/media/ic_md_thumbup.2b89a1fc11234f88d3043dfd15cb92b1.svg";
export { ForwardRef as ReactComponent };